export const RESOLUTION = 1;
export const APP_WIDTH = 1080 * RESOLUTION;
export const APP_HEIGHT = 2330 * RESOLUTION;
export const CARD_HEIGHT = 280 * RESOLUTION;
export const CARD_WIDTH = 194 * RESOLUTION;

export const getProxiedCardImageUrl = (imgUrl) => {
    const extractedImgNameAndExt = imgUrl.split('/').pop();
    return "/proxy/image/" + extractedImgNameAndExt;
};